import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Plenti is merchant-funded: the customer sees "0%", Plenti charges the merchant a rate per
// tenure. To net the financed amount, we gross it up:  Portal = financed / (1 - rate).
export const plentiRows = (amount, config) => {
  const amt = Number(amount) || 0;
  const mf = Number(config?.monthly_fee) || 0;
  const otf = Number(config?.one_time_fee) || 0;
  const tenures = config?.tenures || [];
  return tenures.map((t) => {
    const rate = (Number(t.rate) || 0) / 100;
    const portal = rate < 1 ? Math.round(amt / (1 - rate)) : 0;
    const monthlyFees = mf * t.months;
    const total = portal + monthlyFees + otf;
    const monthly = t.months ? total / t.months : 0;
    const extra = total - amt;
    return { months: t.months, years: +(t.months / 12), rate: Number(t.rate) || 0,
      portal, monthlyFees, oneTime: otf, total, monthly, extra };
  });
};

export const money = (n) => "$" + Math.round(Number(n) || 0).toLocaleString("en-AU");
export const money2 = (n) => "$" + (Number(n) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const downloadPlentiPdf = (amount, config) => {
  const rows = plentiRows(amount, config);
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  doc.setFontSize(16); doc.setTextColor(11, 42, 26);
  doc.text("Plenti Finance Calculation", 14, 15);
  doc.setFontSize(9); doc.setTextColor(80);
  doc.text(`Amount to be financed: ${money(amount)}     Monthly account fee: ${money2(config.monthly_fee)}/mo     One-time fee: ${money(config.one_time_fee)}`, 14, 22);
  autoTable(doc, {
    startY: 27,
    head: [["Amount\nfinanced", "Interest\n%", "Tenure\n(Years)", "Tenure\n(Months)", "Amount to\nenter on portal", "Monthly\nfees", "One-time\nfee", "Total\ncustomer pays", "Monthly\nrepayment", "Extra paid\nby customer"]],
    body: rows.map((r) => [money(amount), r.rate.toFixed(2) + "%", r.years, r.months, money(r.portal), money(r.monthlyFees), money(r.oneTime), money(r.total), money2(r.monthly), money(r.extra)]),
    styles: { fontSize: 8, halign: "center", cellPadding: 2 },
    headStyles: { fillColor: [11, 42, 26], textColor: 255, fontSize: 7.5 },
    columnStyles: { 4: { fillColor: [255, 247, 205], fontStyle: "bold" }, 8: { fillColor: [255, 247, 205], fontStyle: "bold" } },
  });
  const y = doc.lastAutoTable.finalY + 8;
  doc.setFontSize(7.5); doc.setTextColor(120);
  doc.text("Portal amount = financed amount / (1 - merchant rate). Monthly repayment includes the monthly account fee and the one-time fee spread across the term. Figures are indicative.", 14, y, { maxWidth: 270 });
  doc.save(`Plenti-Calculation-${Math.round(Number(amount) || 0)}.pdf`);
};
